import { render, staticRenderFns } from "./DayOfWeekPreview.vue?vue&type=template&id=4af4da19&lang=pug&"
import script from "./DayOfWeekPreview.vue?vue&type=script&lang=js&"
export * from "./DayOfWeekPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports